const dataDict = {
  state: {
    //启用状态
    enableStatus: {
      1: '启用',
      0: '停用'
    },
    
    userType : {
      0: '金牌师傅',
      1: '业务员',
      2: '广告服务商',
      3: '客户',
      4: '水电工',
      5: '公司人员',
      6: '经销商',
      7: '门店',
    
    },
    
    //部门类型
    deptType: {
      1: '区域',
      2: '经销商',
      3: '门店',
      4: '普通部门',
    },
    //员工在职状态
    employeesStatus: {
      0: '不在职',
      1: '在职'
    },
    //订单状态
    orderStatus:{
      1: '信息预录入',
      2: '已预约',
      3: '已分配金牌师傅',
      4: '待上门',
      40:'已上门',
      41:'已检测',
      5: '已完成',
      6: '已评价',
      7: '已结算',
      8: '不合格'
    },
    applyStatus:{
      0:"待审核",
      1:'审核通过',
      2:'审核不通过'
    },
    //有无VR图
    hasVr: {
      1: '有',
      0: '无'
    },
    //终端类型
    terminalType:{
      1:'代理商',
      2:'分销商',
      3:'零售网点',
      4:'装饰公司',
      5:'工程客户',
      6:'墙体广告'
    },
    terminalStatus:{
      1:'新建终端',
      2:'自有终端'
    },
    saleModel:{
      1:'批发',
      2:'零售',
      3:'批发、零售',
    },
    storeLevel:{
      1:'旗舰店',
      2:'形象店',
      3:'标准店',
    },

    visitWay:{
      1:'电话',
      2:'上门'
    },

    //终端广告状态
    adStatus:{
      '0':'制作需求申请',
      '1':'制作商初步方案',
      '2':'确认方案',
      '3':'制造商提请广告验收',
      '4':'验收完成',
      '41':'验收不通过',
      '5':'已核对验收清单'
    },

    adType:{
      1:'门头广告',
      2:'墙体广告'
    },


    evaluateValType:{
      1:'非常满意',
      2:'满意',
      3:'不满意'
    },

    visitState:{
      0:'待拜访',
      1:'已拜访'
    },

    applyType:{
      0:'业主',
      1:'电工',
      2:'经销商',
      3:'装饰公司',
      4:'项目经理',
      5:'工长',
      6:'金牌师傅'

    },
    oaspZt:{
      submit:'已提交',
      reject:'退回',
      archive:'归档'
    }


  }
}

export default dataDict
